<template>
  <div id="app">
    <meta name="description" content="收音机,小旋风收音机,网络收音机,网络电台,小旋风,收音机app,电台app,中国之声,云听,喜马拉雅,蜻蜓,经济之声">
    <img style="width: 100px;height: 100px;" alt="Vue logo" src="./assets/logo.png">
    <div class="custom-text" style="font-weight: 1000;font-size: 28px;">小旋风收音机</div> 
    <InvitePage/>
  </div>
</template>

<script>
import InvitePage from './components/InvitePage.vue'

export default {
  name: 'App',
  components: {
    InvitePage
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
